import { PAGE_KEYS } from "../_core/pageKeys";
import { SECTION_KEYS } from "../_core/sectionKeys";
import { PAGE_TEMPLATE_TYPES, TEMPLATE_KEYS } from "../_core/templateTypes";
import { createAustraliaComboOrder } from "./api/combo";
import { normalizeAustraliaOrderListItem } from "./utils/orderList";

export default {
  key: TEMPLATE_KEYS.AUSTRALIA,
  defaultLocale: "en",
  defaultCurrency: "AUD",
  features: {
    supportsComboProducts: true,
  },
  checkout: {
    lineId: {
      enabled: false,
      required: false,
    },
    phone: {
      preset: "au",
    },
    delivery: {
      enabledModes: ["delivery"],
    },
    payment: {
      enabledMethods: ["online"],
      defaultMethod: "online",
      provider: "conflux",
      currency: "AUD",
    },
    continuePayment: {
      mode: "cashier",
      provider: "conflux",
      cashierPath: "/sub/payment/cashier",
    },
    addressLibrary: {
      source: "local",
      dataset: "australia",
    },
    forms: {
      shippingAddress: {
        fields: {
          postalCode: {
            enabled: true,
            required: true,
            normalize: "digits",
            maxLength: 4,
            pattern: "^\\d{4}$",
          },
        },
      },
    },
  },
  order: {
    create: createAustraliaComboOrder,
    normalizeListItem: normalizeAustraliaOrderListItem,
  },
  resources: {
    layoutHeaderUrl: "au-layout-header",
    layoutFooterUrl: "au-layout-footer",
    userHeaderUrl: "au-layout-user-header",
    userFooterUrl: "au-layout-user-footer",
  },
  pages: {
    [PAGE_KEYS.HOME]: {
      type: PAGE_TEMPLATE_TYPES.LOWCODE,
      lowcodeUrl: "au-shoppc",
      layout: "default",
    },
    [PAGE_KEYS.CART]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/CartPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.PRODUCT]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/ProductListPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.PRODUCT_DETAIL]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/ProductDetailPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.PRODUCT_LIST]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/ProductListPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.PRODUCT_SEARCH]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/ProductListPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.CATEGORY]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/ProductListPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.USER_ORDER_DETAIL]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/OrderDetailPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.PUBLIC_ORDER_DETAIL]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/OrderDetailPage.vue"),
      layout: "default",
    },
    [PAGE_KEYS.PAYMENT_SUCCESS]: {
      type: PAGE_TEMPLATE_TYPES.COMPONENT,
      component: () => import("./pages/PaymentSuccessPage.vue"),
      layout: "default",
    },
  },
  sections: {
    [SECTION_KEYS.NAVIGATION_BAR]: {
      component: () => import("./sections/NavigationBar.vue"),
    },
    [SECTION_KEYS.PAYMENT_CART_ITEMS]: {
      component: () => import("./sections/PaymentCartItems.vue"),
    },
  },
};
